import React from "react";
import { Link } from "react-router-dom";

import { Card, Icon } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import webdashboardVideo from "assets/webdashboard.mp4";

const WelcomeMark = () => {
  return (
    <Card sx={{
      height: "340px",
      py: "32px",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0
        }}
      >
        <source src={webdashboardVideo} type="video/mp4" />
      </video>
      
      {/* Dark Overlay - Full Size */}
      <VuiBox 
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.5))",
          zIndex: 1
        }}
      />
      
      {/* Content */}
      <VuiBox 
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          px: "32px",
          py: "32px"
        }}
      >
        <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
          <VuiBox>
            <VuiTypography color="text" variant="button" fontWeight="regular" mb="12px">
              Welcome to
            </VuiTypography>
            <VuiTypography color="white" variant="h3" fontWeight="bold" mb="18px">
              Mytherra Wallet
            </VuiTypography>
            <VuiTypography color="text" variant="h6" fontWeight="regular" mb="auto">
              Your secure gateway to the
              <br /> Mytherra blockchain.
            </VuiTypography>
          </VuiBox>
          <VuiTypography
            component={Link}
            to="/tables"
            variant="button"
            color="white"
            fontWeight="regular"
            sx={{
              mr: "5px",
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",

              "& .material-icons-round": {
                fontSize: "1.125rem",
                transform: `translate(2px, -0.5px)`,
                transition: "transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)",
              },

              "&:hover .material-icons-round, &:focus  .material-icons-round": {
                transform: `translate(6px, -0.5px)`,
              },
            }}
          >
            View Transactions
            <Icon sx={{ fontWeight: "bold", ml: "5px" }}>arrow_forward</Icon>
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default WelcomeMark;
